import React, { FC, ReactNode } from "react";
import { Grid } from "@material-ui/core";
import MenuSectionTitle from "./Components/MenuSectionTitle";
import MenuLink from "./Components/MenuLink";
import SetContainer from "./Components/SetContainer";

const Content = ({ title, external, absolute, relative, below }): ReactNode => {
  return (
    <SetContainer>
      {/* relative property must be set to "" for it to become unclickable */}
      <MenuSectionTitle
        title={title}
        relative={relative}
        external={external}
        absolute={absolute}
      />
      <div>
        {below &&
          below.length > 0 &&
          below.map(({ key, title, external, absolute, relative }) => (
            <MenuLink
              key={key}
              title={title}
              relative={relative}
              absolute={absolute}
              fontWeight="600"
              external={external}
            />
          ))}
      </div>
    </SetContainer>
  );
};

const PopoverMenu = ({ menu = [] }): FC => {
  const displayCols = (): ReactNode => {
    return menu.map((item, idx) => (
      <Grid item md={4}>
        {item.map((prop, idx) => (
          <>
            <Content {...prop} />
            {idx !== item.length - 1 && <br />}
          </>
        ))}
      </Grid>
    ));
  };
  return (
    <Grid container spacing={0} direction="row">
      {displayCols()}
    </Grid>
  );
};

export default PopoverMenu;
